import React from 'react';
import styled from 'styled-components';

import desktopImg from './desktop-mast.png';
import mobileImg from './mobile-mast.png';

const HeroStyle = styled.div`
	background-image: url(${(p) => p.desktopBimg});
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	height: 33vw;

	a {
		display: inline-block;
		height: 100%;
		width: 100%;
	}

	@media (max-width: 767px) {
		background-image: url(${(p) => p.mobileBimg});
		height: 100vw;
	}
`;

export default () => {
	return (
		<HeroStyle desktopBimg={desktopImg} mobileBimg={mobileImg} className="hero">
			<a
				href="https://www.instagram.com/arcadiaacademyofmusic/"
				target="_blank"
				rel="noopener noreferrer"
			></a>
		</HeroStyle>
	);
};
